import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert, Typography, Button } from "@mui/material";
import axios from "axios";
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import Select from "@mui/material/Select";
//import Option from "@mui/material/Option";
//import Button from '@material-ui/core/Button';
//import Envios from "./Envios";
//import SearchBar from "./SearchBar"
//import DatePicker from "react-datepicker";
//import "../search.css";
//import "../stylesheets/datepicker-cssmodules.scss"
//import "react-datepicker/dist/react-datepicker.css";

//const Dashboard = () => {  
function Dashboard() {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const username = userData?.username;
  const clienteid = userData?.clienteid;
  const empresaid = userData?.empresaid;
  const imagen_cliente = userData?.imagen_cliente;
  const tipocuenta = userData?.tipocuenta; 
  const [apiResponse, setApiResponse] = useState("");
  const [apiResponseEmp, setApiResponseEmp] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [empresa, setEmpresa] = useState([]);
  const [apiResponse2, setApiResponse2] = useState("");
  const [pedidos2, setPedidos2] = useState([]);
  //const Total2 =  useState([]);
  const [Total, setApiResponse3] = useState("");
  //const [status_Desc, setstatus_Desc] = useState("");
  const [Listo_Para_Enviar, setApiResponse4] = useState("");
  const [En_Transito, setApiResponse5] = useState("");
  const [Entregado, setApiResponse6] = useState("");
  const [No_Entregado, setApiResponse7] = useState("");
  const [height, setHeight] = useState(0)
  const ref = useRef(null)
  ///const [startDate, setStartDate] = useState(new Date());
  //const [monthDate, setMonthDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(new Date());
  const [postDate, setPostDate] = useState("");
  const [postEmp, setPostEmp] = useState("");
  const [postMes, setPostMes] = useState((fromDate.getMonth()+1).toString().padStart(2, "0"));
  const [postSearch, setPostSearch] = useState("");

  const meses = [
    {
      value: '01',
      label: 'Enero',
    },
    {
      value: '02',
      label: 'Febrero',
    },
    {
      value: '03',
      label: 'Marzo',
    },
    {
      value: '04',
      label: 'Abril',
    },
    {
      value: '05',
      label: 'Mayo',
    },
    {
      value: '06',
      label: 'Junio',
    },
    {
      value: '07',
      label: 'Julio',
    },
    {
      value: '08',
      label: 'Agosto',
    },
    {
      value: '09',
      label: 'Septiembre',
    },
    {
      value: '10',
      label: 'Octubre',
    },
    {
      value: '11',
      label: 'Noviembre',
    },
    {
      value: '12',
      label: 'Diciembre',
    },
  ];

  function getEmpresas() {
    axios
    .post("https://boxerlogistica.com/api/getEmpresas.php", {
      empresaid: empresaid, tipocuenta: tipocuenta
    })
    .then(function(response3){
      //const empresa = response3.data.data;
      //console.log(response3.data.data);
      setApiResponseEmp(response3.data.message);
      setEmpresa(response3.data.data); 
    }); 
  }

  const handleSubmit = (event) => {
      event.preventDefault()

      // log form content
      //console.log(postEmp)
      //console.log(postMes)
      //console.log(postSearch)
      //console.log(postDate)
      

      axios
     .post("https://boxerlogistica.com/api/envios_admin.php", {
       clienteid: clienteid, tipocuenta: tipocuenta, postDate: postDate, postMes: postMes, postSearch: postSearch, postEmp: postEmp

     })
     .then(function(response){
       console.log(response.data);
       setApiResponse(response.data.message);
       setPedidos(response.data.data);
      // const empresa3 = JSON.stringify(response.data.data);
      // const PedidoData2 = JSON.parse(empresa3);
    //console.log(PedidoData2[0].contactoOrigen);
  
    //console.log(empresa3);

    //setstatus_Desc(PedidoData2[0].status_Desc);

     }); 
  }

  
  const handleUploadImg = (event, message) => {
    
    //console.log(event.target);

    //console.log(message);

    //console.log('Image clicked');
    sessionStorage.setItem("seguimientoIDActual", '');
    sessionStorage.setItem("seguimientoIDActual", message);
    window.location.href = "/GuiaImprimir";
      
}

  const handleImprimir = (event, message) => {
    
    //console.log(event.target);

    //console.log(message);

    //console.log('Image clicked');
    sessionStorage.setItem("seguimientoIDActual", '');
    sessionStorage.setItem("seguimientoIDActual", message);
    window.location.href = "/GuiaImprimir";
      
}

const handlePedidoChange = (event, message, id) => {
    
  //console.log(event.target.value);

  //console.log(message);
  const status_DescE = event.target.value;
  const idPaquete = id;
  const select_seguimientoID = message;

  axios
      .post("https://boxerlogistica.com/api/update_Envio.php", {
        status_Desc: status_DescE,
        idPaquete: idPaquete,
        select_seguimientoID: select_seguimientoID
      })
      .then((response) => {
        //console.log(response);
        setApiResponse(response.data.status);
        if (response.data.status === "success") {
          console.log(response);
        }else{
          console.log(response);
        }
      })
      .catch((error) => {
        console.error(error);
        setApiResponse(error.response.data.message);
      });

  //setstatus_Desc(event.target.value);

  //sessionStorage.setItem("seguimientoIDActual", '');
  //sessionStorage.setItem("seguimientoIDActual", message);
  //event.target.value
    
}

  const handleClearForm = (event) => {
    event.preventDefault()

    // log form content
    
    //console.log(postEmp)
    //console.log(postMes)
    //console.log(postSearch)
    //console.log(postDate)

    
  setPostDate("");
  setPostEmp('0');
  setPostMes('0');
  setPostSearch("");

  }

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("loggedIn");

    setHeight(ref.current.clientHeight)
       
    if (!loggedIn) {
      navigate("/login");
    }else if (tipocuenta!='Admin') {
      navigate("/login");
    }else{
      getPedidos();
      getPedidos2();
      getEmpresas();
    }
  }, [navigate]);


  function getPedidos() {
    const inicio = 10;
     axios
     .post("https://boxerlogistica.com/api/envios_admin.php", {
       clienteid: clienteid, tipocuenta: tipocuenta, inicio: inicio

     })
     .then(function(response){
       console.log(response.data);
       setApiResponse(response.data.message);
       setPedidos(response.data.data);
       //const empresa3 = JSON.stringify(response.data.data);
       //const PedidoData2 = JSON.parse(empresa3);
       //setstatus_Desc(PedidoData2[0].status_Desc);
     }); 
 }

 function getPedidos2() {
  axios
  .post("https://boxerlogistica.com/api/envios2_admin.php", {
    clienteid: clienteid, tipocuenta: tipocuenta
  })
  .then(function(response2){
    console.log(response2.data);
    setApiResponse2(response2.data.message);
    setPedidos2(response2.data.data);
    sessionStorage.setItem("PedidoData", JSON.stringify(response2.data.data));
    const PedidoData = JSON.parse(sessionStorage.getItem("PedidoData"));
    setApiResponse3(PedidoData?.Total);
    setApiResponse4(PedidoData?.Listo_Para_Enviar);
    setApiResponse5(PedidoData?.En_Transito);
    setApiResponse6(PedidoData?.Entregado);
    setApiResponse7(PedidoData?.No_Entregado);
  }); 
}


  return (
    
    <Container>
      
      <div>
          <div className="Dashboard-container" height="{height}" ref={ref}>
              <div className="div-left_Dashboard">
                <ul className="footer">
                  <li color="#ea7004">
                    <table>
                      <tbody>
                      <tr><td align="center"><img src={"/images/clientes/" + imagen_cliente} alt="Cliente" class="img_Dashboard"></img>
                      <br></br>
                      <span className="dashboard_user">{username}</span>
                      </td></tr>
                      <tr><td><br></br></td></tr>
                      <tr><td align="center">
                            <span>&nbsp;</span> 
                      </td></tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
              <div className="div-right_Dasboard">
                        <div >
                        <Typography variant="h4" gutterBottom>
                                  Bienvenido, {username}!
                            </Typography>
                            <br />  
                              <ul className="footer">        
                                <li>
                                  <div className="box">
                                    <span className="menu1">Pedidos Totales</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu1_value">{Total}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu2">Listos Para Enviar</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu2_value">{Listo_Para_Enviar}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu3">En Transito</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu3_value">{En_Transito}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu4">Entregado</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu4_value">{Entregado}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu5">No Entregado</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu5_value">{No_Entregado}</span>
                                  </div>
                                </li>
                                </ul>
                            
                        </div>
            
                <br></br>
                <br></br>
                        <div className="box_env">
                        <form id="external-form" onSubmit={handleSubmit}>
                          <table float="right" >
                          <tbody>
                              <tr>
                              <td >
                                  <div className="form-group">
                                  {tipocuenta === "Admin" ? (  
                                  <Select
                                      id="postEmp"
                                      labelId="postEmp"
                                      label="Seleccione una Empresa"
                                      defaultValue="0"
                                      value={postEmp}
                                      //placeholder="Seleccione una Empresa"
                                      onChange={event => setPostEmp(event.target.value)}
                                      sx={{
                                        width: 200
                                      }}
                                    >
                                      <MenuItem key="0" value="0">
                                      -----
                                    </MenuItem>
                                    {empresa ? empresa.map((option2)  => (
                                        <MenuItem key={option2.value} value={option2.value}>
                                        {option2.label}
                                         </MenuItem>
                                    )) : null } 
                                </Select>
                                ) : (
                                  <span>&nbsp;</span> 
                                )}      
                                  
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                  <TextField
                                    type="text"
                                    value={postDate}
                                    onChange={event => setPostDate(event.target.value)}
                                    variant="outlined"
                                    id="postDate"
                                    label="DD/MM/YYYY"
                                    size="small"
                                    fullWidth
                                  />
                                  </div>
                                </td>
                                <td>
                                <div className="form-group">
                                <TextField
                                  id="postMes"
                                  size="small"
                                  select
                                  label="Mes"
                                  onChange={event => setPostMes(event.target.value)}
                                  //defaultValue=""
                                  value={postMes}
                                  defaultValue={(fromDate.getMonth()+1).toString().padStart(2, "0")}
                                  //helperText="Seleccione un Mes"
                                  sx={{
                                    width: 100
                                  }}
                                >
                                  <MenuItem key="0" value="0">
                                      -----
                                    </MenuItem>
                                  {meses.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                  <TextField
                                    type="text"
                                    value={postSearch}
                                    onChange={event => setPostSearch(event.target.value)}
                                    variant="outlined"
                                    id="postSearch"
                                    label="Buscar"
                                    size="small"
                                    fullWidth
                                  />
                                  </div>
                                </td>
                                
                                <td>
                                    <button type="submit" className="submitBtn">Buscar</button>
                                    
                                </td>
                              </tr>
                              <tr><td colSpan="5" align="right"><Button onClick={handleClearForm}>Borrar Filtros</Button></td></tr>
                              </tbody>
                            </table>
                            </form>
                          </div>
                <br></br>
                <br></br>
                        <div className="box_env">
                            <table float="right" >
                            <tbody>
                            <tr >
                              <td align="right" float="right">
                              <div class="table-responsive">
                                <table class="table table-hover" id="job-table">
                                  <thead>                             
                                      <tr >
                                        <th width="15%">
                                            Seguimiento ID
                                        </th>
                                        <th>    </th>
                                        <th width="30%">
                                            Nombre del Remitente
                                        </th>
                                        <th>    </th>
                                        <th width="30%">
                                            Nombre del Destinatario
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                            Estado
                                        </th>
                                        <th>   </th>
                                        <th width="10%">
                                            
                                        </th>
                                      </tr>
                                      <tr>
                                          <td colspan="9">
                                            <hr></hr>
                                          </td>
                                        </tr>
                                      </thead>
                                      <tbody class="text-center tableBody">
                            {pedidos ? pedidos.map((pedido, key) =>
                              <>
                                        <tr key={key}>
                                          <td>
                                              {pedido.seguimientoIDP}
                                          </td>
                                          <td> </td>
                                          <td>
                                              {pedido.nombreOrigen}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.nombreDestino}
                                          </td>
                                          <td></td>
                                          <td>
                                          <Select
                                            id={key}
                                            defaultValue={pedido.status_DescE}
                                            label="Estatus"
                                            onChange={(event) => handlePedidoChange(event, pedido.seguimientoID, pedido.id)}
                                          >
                                            <MenuItem value="Listos Para Enviar">Listos Para Enviar</MenuItem>
                                            <MenuItem value="En Transito">En Transito</MenuItem>
                                            <MenuItem value="Entregado">Entregado</MenuItem>
                                            <MenuItem value="No Entregado">No Entregado</MenuItem>
                                            <MenuItem value="En Proceso">En Proceso</MenuItem>
                                          </Select>
                                          </td>
                                          <td></td>
                                          <td>
                                           <img src="/images/pdf.png" 
                                           onClick={(event) => handleImprimir(event, pedido.seguimientoID)}></img>
                                           <img src="/images/uploadImg.png" class="img_upd"
                                           onClick={(event) => handleUploadImg(event, pedido.seguimientoID)}></img>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan="9">
                                            <hr></hr>
                                          </td>
                                        </tr></>  
                              ) : null } 
                                         </tbody>
                                        </table>
                                        </div>
                                        </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
              </div>
          </div>    
      </div>
      <br></br>
      <br></br>
 </Container>
    
  );

  

}

export default Dashboard;
